import * as React from 'react';
import { getFirstSalesHistoryItemId, getSlugItemId } from '@/redux/modules/priceResults/priceResults.selectors';
import { PriceResultsCarousels } from './components/PriceResultsCarousels/PriceResultsCarousels';
import { PriceResultsItem } from './components/PriceResultsItem/PriceResultsItem';
import { PriceResultsPageBreadcrumbs } from './components/PriceResultsPageBreadcrumbs/PriceResultsPageBreadcrumbs';
import { PriceResultsUpcomingSales } from './components/PriceResultsUpcomingSales/PriceResultsUpcomingSales';
import { recordAnalyticsForPriceResultPageView } from '@/redux/modules/analytics';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useLocation, useParams } from 'react-router-dom';
import { waitToDispatch } from '@/utils/waitToDispatch/waitToDispatch';
import PriceResultsPageHeaderMeta from '@/pages/Item/PriceResultsPage/components/PriceResultsHeaderMeta/PriceResultsPageHeaderMeta';
import usePrevious from '@liveauctioneers/caterwaul-components/lib/hooks/usePrevious';

const PriceResultsPage = () => {
    const location = useLocation();

    const slugItemId = useAppSelector(getSlugItemId);
    const historyItemId = useAppSelector(getFirstSalesHistoryItemId);
    const urlItemId = Number(location.search.match(/itemId=(\d+)/)?.[1]);

    const itemId = urlItemId || slugItemId || historyItemId;
    const { slugId } = useParams<{ slugId: string }>();

    const prevItemId = usePrevious(itemId);
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (prevItemId !== itemId) {
            waitToDispatch(recordAnalyticsForPriceResultPageView, dispatch, {
                itemId,
                location,
            });
        }
    }, [dispatch, itemId, location, prevItemId, slugId]);

    return (
        <div
            className="m-auto w-full max-w-[1200px] px-md xsMax:m-0 xsMax:p-0 xsMax:px-0"
            data-testid="price-results-page"
        >
            <PriceResultsPageHeaderMeta
                itemId={itemId}
                slug={slugId}
            />
            <PriceResultsPageBreadcrumbs itemId={itemId} />
            <div className="flex flex-col gap-2xl xsMax:gap-lg">
                <PriceResultsItem itemId={itemId} />
                <PriceResultsCarousels itemId={itemId} />
                <PriceResultsUpcomingSales
                    itemId={itemId}
                    slug={slugId}
                />
            </div>
        </div>
    );
};

export default PriceResultsPage;
